import type { ButtonHTMLAttributes, ReactElement } from "react"
import type { LinkProps } from "react-router"
import { Link } from "react-router"

import Tooltip from "@mui/material/Tooltip"

const GridActionTooltip = ({
  children,
  title,
}: {
  children: ReactElement
  title: string
}) => (
  <Tooltip describeChild disableInteractive title={title}>
    {children}
  </Tooltip>
)

const gridActionTooltipTitle = (ariaLabel?: string) => ariaLabel ?? ""

/**
 * GridActionsCellItem `component` that shows an MUI tooltip on hover and
 * keyboard focus of a link action (View, Edit).
 */
export const GridActionTooltipLink = (props: LinkProps) => (
  <GridActionTooltip title={gridActionTooltipTitle(props["aria-label"])}>
    <Link {...props} />
  </GridActionTooltip>
)

/**
 * GridActionsCellItem `component` that shows an MUI tooltip on hover and
 * keyboard focus of a button action (Edit, Save, Cancel, Delete). Disabled
 * actions wrap a focusable span so hover and keyboard focus still work.
 */
export const GridActionTooltipButton = (
  props: ButtonHTMLAttributes<HTMLButtonElement>
) => {
  const title = gridActionTooltipTitle(props["aria-label"])

  if (props.disabled) {
    const { tabIndex = 0, ...buttonProps } = props

    return (
      <GridActionTooltip title={title}>
        <span
          aria-label={title || undefined}
          style={{ display: "inline-flex" }}
          tabIndex={tabIndex}
        >
          <button type="button" {...buttonProps} />
        </span>
      </GridActionTooltip>
    )
  }

  return (
    <GridActionTooltip title={title}>
      <button type="button" {...props} />
    </GridActionTooltip>
  )
}
